import React from 'react';

export const Close = () => (
    <path d='M12.707,12L23.854,0.854c0.195-0.195,0.195-0.512,0-0.707s-0.512-0.195-0.707,0L12,11.293L0.854,0.146
        c-0.195-0.195-0.512-0.195-0.707,0s-0.195,0.512,0,0.707L11.293,12L0.146,23.146c-0.195,0.195-0.195,0.512,0,0.707
        c0.195,0.195,0.512,0.195,0.707,0L12,12.707l11.146,11.147c0.195,0.195,0.512,0.195,0.707,0c0.195-0.195,0.195-0.512,0-0.707
        L12.707,12z' />
);